<mbs-card-group>
  <ng-container *ngTemplateOutlet="credentialsTmp"></ng-container>
</mbs-card-group>

<ng-template #credentialsTmp>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.accountId"
      [boldLabel]="true"
      [formControl]="accountId"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.id' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.id' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input-password
      [attr.data-e2e]="e2eLocators.applicationKey"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [disabledEye]="applicationKey.value === fakeSecretKey"
      [formControl]="applicationKey"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.key' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.key' | i18next"
      [showRequiredMark]="false"></mbs-input-password>
  </mbs-form-group>
</ng-template>
